
import { reducer } from '../../utils/helpers'

export default function createFrameStorage(frameStorage, paths, filter) {
  return store => {

    store.subscribe((mutation, state) => {
      if (mutation.type != 'syncState' && frameStorage.connected && state && filter(mutation)) {
        const newState = reducer(state, paths)
        frameStorage.update(newState)
      }
    })

  }
}
